import React from "react";
import {
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from "../../utility/helper";

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    cellContent: {
        width: '100px',
        flexBasis: '180px',
        // padding: 8
    }
}));

const DraftRegistrationAccordianCard = (props) => {
    const classess = useStyles();
    const { item } = props;
    const RegistrationInfo = item.actualData;
    console.log("RegistrationInfo", RegistrationInfo, item, RegistrationInfo.eventForm !== null && RegistrationInfo.eventForm.FormFields[0].find(x => x.FieldValue === true && x.FieldName !== 'NotAttend'));
    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none" }} >
                <CardContent className={classess.cardContent}>
                    {/* <Box className={classes.rowContent}> */}
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(7,1fr)',
                        flexDirection: 'row',
                        textAlign: 'left',
                        justifyContent: 'left',
                        alignItems: 'left',
                        gap: '10px',
                        flexbasis: '900px'
                    }}>
                        {/* {RegistrationInfo.dob && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Date Of Birth
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.dob}</span>
                                </Typography>
                            </Box>
                        </Box>} */}
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Participant Phone Number
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.contactNo}</span>
                                </Typography>
                            </Box>
                        </Box>
                        {RegistrationInfo.alternateContactName ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Alternate Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.alternateContactName}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.alternateContactNo ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Alternate Phone Number
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.alternateContactNo}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.alternateContactEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Alternate Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.alternateContactEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}

                        {RegistrationInfo.guestList && RegistrationInfo.guestList !== null && RegistrationInfo.guestList?.length > 0 && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Guests
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.guestList.map((x) => `${x.name}`).join(', ')}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.lunchGuestList && RegistrationInfo.lunchGuestList !== null && RegistrationInfo.lunchGuestList?.length > 0 && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Lunch Guests
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.lunchGuestList.map((x) => `${x.name}`).join(', ')}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.eventForm !== null && RegistrationInfo.eventForm.FormFields[0] ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Participant Option
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.eventForm.FormFields[0].find(x => x.FieldValue === true).Description}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.eventForm !== null && RegistrationInfo.eventForm.FormFields[1] ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Family Option
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.eventForm.FormFields[1].find(x => x.FieldValue === true ).Description}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.hometown ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Hometown
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.hometown}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.state ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    State
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.state}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.country ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Country
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.country}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.university ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    College or Club
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.university}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.pronunciationNotes ? (<Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Pronunciation Notes
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.pronunciationNotes}</span>
                                </Typography>
                            </Box>
                        </Box>) : null}
                        {RegistrationInfo.lastModifiedDate !== "0001-01-01T00:00:00"
                            && RegistrationInfo.lastModifiedDate !== null ?
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified Date
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{Helper.FormatDateTime(RegistrationInfo.lastModifiedDate)}</span>
                                    </Typography>
                                </Box>
                            </Box>
                            : ""}

                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default DraftRegistrationAccordianCard;